import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getHelpContent } from '../content/helpContent';

// 화면 우측 하단의 "?" 도움말 버튼 + 우측 슬라이드 패널.
// 2026-09: "각 화면에 ? 아이콘을 두고 사용자 매뉴얼을 즉시 참고할 수 있게 해달라"는 요청으로 신설.
// Layout.jsx에 한 번만 마운트되어 사이트 전체(로그인 후 화면)에서 항상 같은 자리에 떠 있고,
// 현재 라우트(pathname)에 맞는 콘텐츠를 helpContent.js 레지스트리에서 찾아 보여준다.
export default function HelpPanel() {
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const [open, setOpen] = useState(false);

  // 페이지(경로)가 바뀌면 패널을 닫는다 — 다른 화면으로 이동했는데 이전 화면의
  // 도움말이 계속 열려 있으면 헷갈리기 때문.
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const content = getHelpContent(location.pathname, lang);

  return (
    <>
      {/* 도움말 버튼 — 항상 우측 하단 같은 자리 */}
      <button
        onClick={() => setOpen(true)}
        title={lang === 'ko' ? '이 화면 도움말' : 'Help for this screen'}
        style={{
          position: 'fixed', right: 24, bottom: 24, zIndex: 1100,
          width: 48, height: 48, borderRadius: '50%', border: 'none',
          background: '#534AB7', color: '#fff', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 20, fontWeight: 700, boxShadow: '0 4px 14px rgba(83,74,183,0.4)',
          transition: 'transform 0.15s, box-shadow 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.06)'; }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
      >
        ?
      </button>

      {/* 배경 오버레이 — 클릭하면 닫힘 */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 1290 }}
        />
      )}

      {/* 우측 슬라이드 패널 */}
      <div
        style={{
          position: 'fixed', top: 0, right: 0, bottom: 0, zIndex: 1300,
          width: 420, maxWidth: '92vw', background: '#fff',
          boxShadow: '-4px 0 24px rgba(0,0,0,0.18)',
          transform: open ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.22s ease-out',
          display: 'flex', flexDirection: 'column',
        }}
      >
        <div style={{
          padding: '1.25rem 1.5rem', borderBottom: '1px solid #eee',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0,
        }}>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#333' }}>
            💡 {content ? content.title : (lang === 'ko' ? '도움말' : 'Help')}
          </h2>
          <button onClick={() => setOpen(false)}
            style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#888', lineHeight: 1 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: '1.25rem 1.5rem', overflowY: 'auto', flex: 1 }}>
          {content ? (
            content.sections.map((sec, idx) => (
              <div key={idx} style={{ marginBottom: idx === content.sections.length - 1 ? 0 : 20 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#534AB7', marginBottom: 5 }}>
                  {sec.heading}
                </div>
                <div style={{ fontSize: 13, color: '#555', lineHeight: 1.7, whiteSpace: 'pre-line' }}>
                  {sec.body}
                </div>
              </div>
            ))
          ) : (
            <div style={{ fontSize: 13, color: '#888', lineHeight: 1.7 }}>
              {lang === 'ko'
                ? '이 화면에 대한 도움말은 아직 준비되지 않았습니다.'
                : 'Help for this screen is not available yet.'}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
